import {IdAndValue} from "../common/IdAndValue";
import {Identifier, makeNumericId} from "../common/Identifier";
import {WorkingHours} from "./WorkingHours";
import {Module} from "../common/Module";
import {isPrivileged} from "../../config/Privileges";
import {TimesheetAreaName} from "./Timesheet";
import {fullName} from "../users/User";
import {Person} from "../common/Person";
import {AuthenticatedUser} from "../users/AuthenticatedUser";





export const UserAttendanceTimeModule: Module = {
    identifier: "user_attendance_time",
    isPrivileged: ( authUser, privilege) =>  isPrivileged(
        authUser,
        TimesheetAreaName,
        UserAttendanceTimeModule.identifier,
        privilege
    )
};

export interface UserAttendanceTime  {
    id: Identifier<number>
    employee: IdAndValue< Identifier< number >, string >
    startAt: Date
    finishAt: Date
    breakTime: WorkingHours
}

export function defaultUserAttendanceTime(
    authUser: AuthenticatedUser,
    date: Date = new Date()
): UserAttendanceTime {
    return {
        id: makeNumericId( 0 ),
        breakTime: 0.5,
        startAt: new Date( date.getFullYear(), date.getMonth(), date.getDate(), 8, 0 ),
        finishAt: new Date( date.getFullYear(), date.getMonth(), date.getDate(), 16, 30 ),
        employee: {
            id: authUser.id,
            value: fullName( authUser )
        }
    };
}